import { Component } from '@theme/component';

/**
 * A custom element that renders a blog posts list with local filtering
 * This version disables pagination since we load all posts at once for filtering
 */
export default class BlogPostsList extends Component {
  connectedCallback() {
    super.connectedCallback();
    // Disable infinity scroll for blog posts since we load all at once
    // The filtering is handled by the inline script in the main-blog.liquid file
  }

  get sectionId() {
    const id = this.getAttribute('section-id');
    if (!id) throw new Error('The section-id attribute is required');
    return id;
  }
}

if (!customElements.get('blog-posts-list')) {
  customElements.define('blog-posts-list', BlogPostsList);
}
